import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BookBasketOffer } from 'app/shared/models/class/basket/basketList';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  order: BookBasketOffer;
}


@Component({
  selector: 'app-open-dialog-comment-basket',
  templateUrl: './open-dialog-comment-basket.component.html',
  styleUrls: ['./open-dialog-comment-basket.component.scss']
})
export class OpenDialogCommentBasketComponent implements OnInit {
  commentForm: UntypedFormGroup;
  showComment = true;
  commentMaxLength = 500;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogCommentBasketComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {
  }

  get f() {
    return this.commentForm.controls;
  }

  private initForm(): void {
    this.commentForm = this.formBuilder.group({
      comment: ['', Validators.maxLength(this.commentMaxLength)]
    });
  }

  confirm() {
    let myOrder = this.data.order;

    if (this.commentForm.value.comment) {
      myOrder.memoMessageUser = this.commentForm.value.comment;
    }

    this.dialogRef.close(myOrder)
  }
}
